import { FILTER } from "@/constants";

export const VALID_FILTERS_KEYS = [
  FILTER.SORTING,
  FILTER.CHANNEL_NAME,
  FILTER.CHANNEL_TYPE,
  FILTER.FREETEXT,
  FILTER.LANGUAGE,
  FILTER.SENTIMENT,
  FILTER.END_DATE,
  FILTER.START_DATE,
  FILTER.MIN_REACH,
  FILTER.MENTION_KIND,
  FILTER.INSIGHT_TYPES,
];

export const MULTI_SELECT_FILTERS = [
  FILTER.CHANNEL_TYPE,
  FILTER.CHANNEL_NAME,
  FILTER.LANGUAGE,
  FILTER.SENTIMENT,
  FILTER.MENTION_KIND,
  FILTER.INSIGHT_TYPES,
];

// Meta field for easy use with calendars, contains start_date/end_date
export const META_DATE_FIELD_NAME = "dates";
